export let navProps = {
    page_number: 1, 
    had_results: false,
    limit: 10,
    total: 0,
    sort_column_name: 'appointment_date',//'t2.appointment_date',
    sort_direction: 0, 
    search_term: '', 
    
    list_type: '', 
    process_id: 0, 
    workshop_id: 0,
    customer_id: null,
    multi_store_search: false,
    pending_approval: false,
    custom_batch: false,
    store_list: [],
    date_range: ['', ''],
    search_term_array: []
}

export const plannerProps = {
    dynamic_tab:{
        active_tab: '1',
        visible: false,
        label: ''
    },
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.appointment_date',
        sort_direction: 0, 
        search_term: '', 
        search_term_array: []
    },
    list: null,
    search_type: 0,
    store_id: null,
    planner_type: 2, //weekly, monthly, all
    start_date: null,
    end_date: null,
    date_range: ['', ''],
    do_not_mutate_date: false,
    nav_type: '+',
    date_label: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/production/properties.js